import '../App.css';
import '../css/ImageGrid.css'
import { Tooltip } from "react-tooltip";
import { getdailylookDetail } from '../network/get_dailylookDetail';
import { postDailylookComment } from '../network/post_dailtlookComment';
import React, { useState, useEffect, useRef } from 'react';
import { getweeklybest } from '../network/get_weeklybest';
import { gethomebanner } from '../network/get_homebanner';
import { getDailylookComment } from '../network/get_dailylookComment';
import { FaPencilAlt } from 'react-icons/fa';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import { useSearchParams, useNavigate } from 'react-router-dom';
import { MdArrowBackIos, MdOutlineIosShare } from "react-icons/md";
import { FaRegHeart, FaTimes, FaHeart } from "react-icons/fa";
import { IoMdHeartEmpty } from "react-icons/io";
import { DailylookDetail } from '../model/dailylook_detail';
import { postFollow } from '../network/post_follow';
import { postUnfollow } from '../network/post_unfollow';
import { getRecommuser } from '../network/get_recommuser';
import ImagePopup from '../components/ImagePopup';
import { MY_URL, toggleDailylookLikes, isUserAuthenticated } from '../client';
import { loginPost } from '../network/login';
import dayjs from 'dayjs';
// dayjs 플러그인 가져오기
import relativeTime from 'dayjs/plugin/relativeTime';
// 한국어 로케일(locale) 가져오기
import 'dayjs/locale/ko'; 
import InfiniteScroll from 'react-infinite-scroll-component'; // InfiniteScroll 라이브러리 임포트 (설치 필요: npm install react-infinite-scroll-component)
import { LoginRequiredModal } from '../components/loginpopup';
import { ProfileRequiredModal } from '../components/profilepopup';

// 플러그인 사용 설정
dayjs.extend(relativeTime); 
// 언어를 한국어(ko)로 설정
dayjs.locale('ko'); 

const TOAST_DURATION = 2000; // 2초
const PAGE_SIZE = 10; // 페이지 크기 상수 정의

const TimeAgo = ({ isoString }) => {
  // 1. dayjs 객체 생성
  const time = dayjs(isoString);
  
  // 2. 현재 시간으로부터 상대적인 시간을 계산 (예: "1년 전", "2시간 전")
  const timeAgoText = time.fromNow();
  return (
    <span style={{marginLeft:'10pt',fontSize:'12px'}} title={isoString}>
      {timeAgoText}
    </span>
  );
};

function Dailylook_detail() {
    const [searchParams] = useSearchParams();
  // URL에서 특정 인자(key)의 값을 가져옴
  const postId = searchParams.get('id');    // 예: '123'
  const posttype = searchParams.get('category'); // 예: 'fashion'
  const [dailylooksArray, setDailylooksArray] = useState(null)
  const [dailylook, setDailylook] = useState(null)
  const [comment, setComment] = useState(null)
  const [homebannerArray, setHomebannerArray] = useState([]); 
  const [postType, setpostType] = useState('d'); 
    const [isPopupOpen, setIsPopupOpen] = useState(false);
         const [showEquipments, setShowEquipments] = useState(true);
                     const [userProfile, setUser] = useState(true);
                const [isrecommview, setIsrecommview] = useState(false);
                const [recommUsers, setRecommUsers] = useState([]);
                            const [islike, setIslike] = useState(false);
    const handleClosePopup = () => {
        setIsPopupOpen(false);
    };
   
         const toggleEquipments = () => {
        setShowEquipments(prev => !prev); // 현재 상태를 반전시킵니다.
    };
 
 async function processData() {
    const savedToken = localStorage.getItem('user');
    if (savedToken) {
    console.log("사용자 인증 정보가 유효합니다.");
} else {
    await loginPost("temp", "temp_user")
}
  
    const dailylookdetail = await getdailylookDetail(postId)
        setpostType(posttype)
      setDailylook(dailylookdetail)
  const dailylookdata = await getweeklybest()
  setDailylooksArray(dailylookdata)
  const homebannerdata = await gethomebanner()
  setHomebannerArray(homebannerdata)
  console.log(postId)
  const comment = await getDailylookComment(0,10,postId)
  console.log(dailylookdetail.user)
  setUser(dailylookdetail.user)
          setIslike(dailylookdetail.is_like)
          const recommuser = await getRecommuser(dailylookdetail.user.id)
          setRecommUsers(recommuser.results || []);
  fetchComments(); // 초기 댓글 로딩 호출
  
}
function CircularImageSquare({ src, alt, size = 100 }) {
  const imageStyle = {
    width: size,       // 가로 크기
    height: size,      // 세로 크기를 가로 크기와 동일하게 설정 (정사각형)
    borderRadius: '50%', // ⭐️ 핵심: 50%로 설정하여 원형으로 만듦
    objectFit: 'cover', // 이미지가 컨테이너를 채우도록 하며, 필요시 잘림
    display: 'block',    // 인라인 요소의 불필요한 여백 제거
     marginRight: '10px'
  };
  return (
    <img src={src} alt={alt} style={imageStyle} />
  );
}
    const toggleRecommUserFollow = async (userToToggle) => {
        const action = userToToggle.is_followed ? postUnfollow : postFollow;
       
        try {
            const updatedUser = await action(userToToggle.id);
           
            // recommsUsers 배열 업데이트: 해당 유저의 is_followed 상태를 토글
            setRecommUsers(prevUsers => 
                prevUsers.map(user => 
                    user.id === updatedUser.id ? updatedUser : user
                )
            );
        } catch (error) {
            console.error("팔로우/언팔로우 실패:", error);
        }
    };
 const imageRef = useRef(null);
  // 2. 이미지의 실제 크기를 저장할 상태
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  // 3. 이미지 로드 완료 시 크기를 측정하여 상태에 저장하는 핸들러
  const handleImageLoad = () => {
    if (imageRef.current) {
      setImageSize({
        width: imageRef.current.offsetWidth,
        height: imageRef.current.offsetHeight,
      });
      console.log(`이미지 로드 완료. 크기: ${imageRef.current.offsetWidth}x${imageRef.current.offsetHeight}`);
    }
  };
  // 4. 버튼의 위치를 이미지 영역 내로 제한하는 함수
  const getLimitedPosition = (dy, dx, buttonWidth, buttonHeight) => {
    const { width: imgW, height: imgH } = imageSize;
    // 이미지 크기가 아직 로드되지 않았다면 원래 위치를 반환 (임시)
    if (imgW === 0 || imgH === 0) {
      return { top: dy, left: dx };
    }
    // Y축 (Top) 제한: 0 이상, (이미지 높이 - 버튼 높이) 이하
    const limitedY = Math.min(
      Math.max(0, dy) + 30,            // 0px보다 작아지지 않게
      imgH - buttonHeight - 5     // 이미지 높이 - 버튼 높이 - 여유 공간
    );
    // X축 (Left) 제한: 0 이상, (이미지 너비 - 버튼 너비) 이하
    const limitedX = Math.min(
      Math.max(0, dx),            // 0px보다 작아지지 않게
      imgW - buttonWidth - 5      // 이미지 너비 - 버튼 너비 - 여유 공간
    );
    console.log(limitedX)
    return { top: limitedY, left: limitedX };
  };
const BUTTON_WIDTH = 60;  // padding, 폰트 크기 등을 고려한 추정 폭
  const BUTTON_HEIGHT = 28; // padding, 폰트 크기 등을 고려한 추정 높이
// ----------------------------------------------------
// 2. 키 설정 팝업 컴포넌트
// ----------------------------------------------------
     const follow = async () => {
       
       if(userProfile.is_followed){
        
        const _user = await postUnfollow(userProfile.id)
       setUser(_user)
       setIsrecommview(false)
       }else{
       const _user = await postFollow(userProfile.id)
       if(_user == 'PROFILE_NOT_FILLED'){
          setShowProfileModal(true)
       }else{
       setUser(_user)
       setIsrecommview(true)
       }
       
       }
    };
    function ShareButton({ linkToCopy }) {
      // 1. 토스트 메시지 표시 상태 관리
      const [showToast, setShowToast] = useState(false);
    
      // 2. 복사 및 알림을 처리하는 단일 함수
      const handleCopy = async () => {
        if (!linkToCopy) {
          console.error("복사할 링크가 없습니다.");
          return;
        }
    
        try {
          // ⭐️ 클립보드 API를 사용하여 링크 복사
          await navigator.clipboard.writeText(linkToCopy);
    
          // ⭐️ 복사 성공 시 토스트 메시지 표시
          setShowToast(true);
    
          // ⭐️ 일정 시간 후 토스트 메시지 숨김
          setTimeout(() => {
            setShowToast(false);
          }, TOAST_DURATION);
    
        } catch (err) {
          console.error('클립보드 복사 실패:', err);
          alert('클립보드 복사에 실패했습니다. 브라우저 권한을 확인해주세요.');
        }
      };
    
      return (
        <div style={styles.container}>
    
                  <MdOutlineIosShare size="24"  onClick={handleCopy} style={{
            marginLeft: '15px', // 아이콘 간의 간격
            cursor: 'pointer',
            marginRight:'5pt'
        }} />
    
    
          {/* ⭐️ 토스트 메시지 (조건부 렌더링) */}
          {showToast && (
            <div style={styles.toast}>
              링크를 복사했습니다. ✅
            </div>
          )}
        </div>
      );
    }
          const like = async () => {
           
           if(islike){
            
            toggleDailylookLikes(dailylook.id)
            setIslike(false)
    
    
           }else{
            toggleDailylookLikes(dailylook.id)
            setIslike(true)
           }
        };
const [searchTerm, setSearchTerm] = useState('');
  // 3. 검색 버튼 클릭 또는 Enter 키 입력 시 실행되는 함수
  const commentpost = async () => {
    if (searchTerm.trim() === '') {
      alert('댓글을 입력하세요');
      return;
    }
    // 여기에 실제 검색 API 호출 로직을 넣거나 상위 컴포넌트로 전달합니다.
    try {
      const newComment = await postDailylookComment(searchTerm, postId);
      setComments(prevComments => [...prevComments, newComment]);
      setSearchTerm('');
    } catch (error) {
      console.error('댓글 게시 실패:', error);
      alert('댓글 게시 중 오류가 발생했습니다.');
    }
  };
  // 4. Enter 키를 눌렀을 때 검색 함수를 실행하는 핸들러
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      commentpost();
    }
  };
  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const goToProfileDetail = (userId) => {
    // 쿼리 파라미터 형태로 인자 구성: ?id=123&category=fashion
    const queryParams = new URLSearchParams({
      id: userId.id,
    }).toString();
    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/profile?${queryParams}`);
  };
  const bannerSettings = {
    dots: true, // 하단에 점(dot) 페이지네이션 표시
    arrows: false, // 이전/다음 버튼 숨김
    infinite: true, // 무한 반복
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 3000,
   
  };
      const navigate = useNavigate();

  // 댓글 관련 상태 추가
  const [comments, setComments] = useState([]); // 댓글 리스트
  const [nextPageKey, setNextPageKey] = useState(0); // 다음 페이지 키 (초기 0)
  const [hasMore, setHasMore] = useState(true); // 더 불러올 데이터가 있는지
  const [isLoading, setIsLoading] = useState(false); // 로딩 상태
  const isLoadingRef = useRef(isLoading);
      const [showLoginModal, setShowLoginModal] = useState(false);
            const [showProfileModal, setShowProfileModal] = useState(false);

  useEffect(() => {
    isLoadingRef.current = isLoading;
}, [isLoading]);

  // 댓글 불러오기 함수
  async function fetchComments() {
    if (isLoadingRef.current || !hasMore) return;

    setIsLoading(true);
    try {
      const response = await getDailylookComment(nextPageKey, PAGE_SIZE, postId);
      console.log(response);

      setComments(prevComments => [...prevComments, ...response.results]);

      // 다음 페이지 키 설정 (pagekey 증가, response.next가 null이면 hasMore=false)
      if (response.next === null) {
        setHasMore(false);
      } else {
        // pagekey가 페이지 번호라면 +1 (API에 따라 조정 필요, 여기서는 pagekey가 offset이나 페이지로 가정)
        setNextPageKey(nextPageKey + 10); // 만약 offset이라면 nextPageKey + PAGE_SIZE로 변경
      }

      // 만약 results.length < PAGE_SIZE라면 더 이상 없음
      if (response.results.length < PAGE_SIZE) {
        setHasMore(false);
      }
    } catch (error) {
      console.error('댓글 불러오기 실패:', error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
   
    processData()
  }, []);
  //   const handleSaveHeightSettings = (min, max) => {
  //   setMinHeight(min.toString()); // API 요청을 위해 문자열로 저장
  //   setMaxHeight(max.toString());
  //   setIsModalOpen(false);
  //   // useEffect가 minHeight/maxHeight 변경을 감지하고 데이터를 초기화 후 재로딩함.
  // };
    if (!dailylook) {
    return <div style={{

          display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '250px',
    }}>


      <span style={{    marginBottom: '30px',
    fontSize: '12pt'}}>불러오는 중..</span>

      <img
                              src={'loading_logo.jpg'}

                              style={{
                                width: '50px',
                                marginRight: '10px'
                                // height: '44px',
                                // borderRadius: '50%',
                                // objectFit: 'cover',
                                // marginRight: '12px',
                              }}
                            />
      

      
      </div>;
  }  

  
  const goBack = () => {
    // navigate(-1)을 호출하여 이전 경로로 이동
    navigate(-1);
  };
  const handleItemClick = (url ,name) => {
        if (url) {
            window.open(url, '_blank');
        } else {
            const googleSearchBaseUrl = 'https://www.google.com/search?q=';
      
      // 2. 검색어(name)를 URL에 안전하게 인코딩
      // 한글이나 특수문자가 포함된 경우를 대비해 인코딩이 필수입니다.
      const encodedName = encodeURIComponent(name);
      
      // 3. 최종 검색 URL 생성
      const finalSearchUrl = googleSearchBaseUrl + encodedName;
      
      // 4. 새 탭에서 Google 검색 결과 페이지 열기
      window.open(finalSearchUrl, '_blank');
        }
    };
 return (
    <div style={styles.mobileContainer}>
                <ImagePopup 
                            isOpen={isPopupOpen} 
                            onClose={handleClosePopup} 
                        />

                                    <LoginRequiredModal
                                isOpen={showLoginModal}
                                onClose={() => setShowLoginModal(false)}
                              />

                              <ProfileRequiredModal
                                isOpen={showProfileModal}
                                onClose={() => setShowProfileModal(false)}
                              />



                              
      {/* 1. 헤더 영역 */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
         
          {/* 알림 및 검색 아이콘 그룹 (좌/우 정렬) */}
          <div style={{width:'30px', marginLeft:'10pt'}}>
            <MdArrowBackIos size="24" onClick={goBack} style={styles.iconStyle} />
          </div>
          {/* 로고 (중앙 정렬) */}
          {         
          postType == 'd'?
            <a style={{fontWeight:'700'}}>데일리룩</a>
            :
            postType == 'p'?
            <a style={{fontWeight:'700'}}>인기 코디</a>:
                        <a style={{fontWeight:'700'}}>주간 모디</a>
          }
         
          <div style={{width:'30px', marginRight:'10pt'}}>
            {/* <MdSearch size="24" color="#e2e2e2ff" style={styles.iconStyle} /> */}
          </div>
        </div>
        {/* 구분선 */}
        <div style={styles.divider} />
      </header>
     
      <section style={styles.infoSection}>
        
<div style={{ display: 'flex',  alignItems: 'center',justifyContent:'space-between',width:'100%',margin:'0px 15px', marginTop:'100px', }}>
  <div style={{display: 'flex'}} onClick={() => goToProfileDetail(dailylook.user)}>
<CircularImageSquare 
        src= {dailylook.user.profile.image == null ? "https://www.studiopeople.kr/common/img/default_profile.png" : dailylook.user.profile.image}  
        alt="정사각형 이미지" 
        size={50} 
         
      />
       <div style={{ display: 'flex', flexDirection: 'column' }}>
        
        {/* 첫 번째 줄: 아이디 */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
            <span onClick={() => setIsPopupOpen(true)} style={{ 
                fontWeight: 'bold', 
                fontSize: '16px',
                color: '#000'
            }}>
                {dailylook.user.username}
            </span>
            {/* 사진 속 금색 뱃지 자리에 들어갈 요소 (선택 사항) */}
            <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                {/* 🥇 또는 이미지를 넣을 수 있습니다. */}
            </span>
        </div>
        {/* 두 번째 줄: 키와 체형 */}
        <div>
          <span style={{ 
            fontSize: '12px', 
            color: '#888' // 회색 텍스트
          }}>
            {dailylook.user.profile.height}
          </span>
          <span style={{ 
            fontSize: '12px', 
            color: '#888',
            margin: '0 5px' // 구분자 간격
          }}>
            ·
          </span>
          <span style={{ 
            fontSize: '12px', 
            color: '#888'
          }}>
            {dailylook.user.profile.body_type}
          </span>
        </div>
        
        
                </div>
                </div>
                 <div style={{ display: 'flex', alignItems: 'center', marginLeft:'0' }}>
        
        {/* 팔로우 버튼 */}
        <button 
            style={{
                backgroundColor: userProfile.is_followed ? '#b7b7b7ff' :'#FF3640', // 사진 속 빨간색
                color: 'white',
                border: 'none',
                borderRadius: '8px', // 둥근 모서리
                padding: '8px 15px',
                fontWeight: 'bold',
                cursor: 'pointer',
                fontSize: '12px',
                width:'80px'
            }}
             onClick={() => {

              const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
            if(storedUserObject.username == 'temp'){
                        setShowLoginModal(true);

            }else{
                                follow()
            }


          }

            }
        >
            {userProfile.is_followed ? "팔로잉" : "팔로우"}
        </button>
        
        {/* 상세 보기 메뉴 버튼 (점 세 개) */}

        {/* <button 
            style={{
                backgroundColor: 'transparent', // 배경 투명
                border: 'none',
                color: '#aaa', // 회색 점
                fontSize: '24px',
                cursor: 'pointer',
                marginLeft: '5px', // 팔로우 버튼과의 간격
                padding: '0 5px',
            }}
            onClick={() => setIsPopupOpen(true)}
        >
              
        </button> */}


      </div>
        
               
      </div>
        
        {/* 임시 박스 (원래 코드의 70px 박스) */}
      </section>
       {isrecommview && recommUsers.length > 0 &&  (
                          <div style={styles.recommFollowContainer}>
                            <div style={styles.headerRow}>
                              <h3 style={styles.recommTitle}>팔로우 추천</h3>
                              <FaTimes size={20} color="#333" onClick={() => {setIsrecommview(false)}} />
                              </div>
                              <div style={styles.recommList}>
                                  {recommUsers.slice(0, 4).map((user) => (
                                      <FollowUserCard 
                                          key={user.id} 
                                          user={user} 
                                          onToggle={toggleRecommUserFollow} 
                                      />
                                  ))}
                              </div>
                             
                          </div>
                      )}
      {/* 3. 베스트 타이틀 */}
      {/* 4. 데일리룩 이미지 */}
        {/* 5. 홈배너 슬라이더 */}
        <div style={{margin: '10pt auto' }}>
            <div style={styles.sliderContainer}>
              <Slider {...bannerSettings}>
                <div>
                      <div style={{position: 'relative'}} ref={imageRef} onLoad={handleImageLoad}>
                          <img 
                            src={dailylook.image} 
                            onClick={toggleEquipments}
                            style={styles.bannerImage} 
                          />
{showEquipments && imageSize.width > 0 && dailylook.equipments.map((item) => {
        
          // 3. 제한된 최종 위치 계산
          const { top, left } = getLimitedPosition(
            item.dy, 
            item.dx, 
            BUTTON_WIDTH, 
            BUTTON_HEIGHT
          );
          // 4. 버튼 스타일 적용
          return (
            <button 
              key={item.name}
              style={{
                ...styles.buttonBase, // 공통 스타일 분리 (아래 정의됨)
                position: 'absolute',
                top: `${top}px`,      // ⭐️ 제한된 top 위치 적용
                left: `${left}px`,    // ⭐️ 제한된 left 위치 적용
              }}
              onClick={() => handleItemClick(item.url, item.name)}
            >
              {item.name}
            </button>
          );
        })}
                      </div>
                  </div>
                {dailylook.more_images.length > 1 && dailylook.more_images.slice(1).map((banner, index) => (
                  // 이미지 배너를 클릭 가능하게 <a> 태그로 감쌈
                  <div key={index}>
                      <a >
                          <img 
                            src={banner.image} 
                            style={styles.bannerImage} 
                          />
                      </a>
                  </div>
                ))}
              </Slider>
            </div>
      </div>
        {/* 6. 인기 데일리룩 문구 */}
      <div style={{padding : '0 3vw'}}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent:'space-between' }}>
       <div style={{ display: 'flex', flexDirection: 'column' }}>
        
        {/* 첫 번째 줄: 아이디 */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
            <span onClick={() => setIsPopupOpen(true)}style={{ 
                fontWeight: 'bold', 
                fontSize: '16px',
                color: '#000'
                
            }}>
                {dailylook.user.username}
            </span>
            {/* 사진 속 금색 뱃지 자리에 들어갈 요소 (선택 사항) */}
            {/* <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                {dailylook.created_at}
            </span> */}
             <TimeAgo isoString={dailylook.created_at} />
        </div>

        
        
                </div>
                 <div style={{ display: 'flex', alignItems: 'center' }}>
        
        {/* 팔로우 버튼 */}
        
        {/* 상세 보기 메뉴 버튼 (점 세 개)FaHeart */}
           <ShareButton linkToCopy= {MY_URL + '/dailylook?id=' + dailylook.id+"&category=d"} />
              {islike?
              <FaHeart size="20"  
              
              onClick={() => 
                
                {
                  const savedToken = localStorage.getItem('user');
                  const storedUserObject = JSON.parse(savedToken);
                  if(storedUserObject.username == 'temp'){
                              setShowLoginModal(true);

                  }else{
                                          like()
                  }    
                }
              } style={{ 
                color : islike ?  '#ff0000ff' : '#000000ff'
              }} />
              :
              
              <FaRegHeart size="20"  
              
              onClick={() => 
                
                {
                  const savedToken = localStorage.getItem('user');
                  const storedUserObject = JSON.parse(savedToken);
                  if(storedUserObject.username == 'temp'){
                              setShowLoginModal(true);

                  }else{
                                          like()
                  }    
                }
              } style={{ 
                color : islike ?  '#ff0000ff' : '#000000ff'
              }} />
            }
      </div>


               
      </div>
            {dailylook.introduction}
      <br/>
            <div style={styles.container}>
            {dailylook.equipments.map((item, index) => (
                <div 
                    key={index} 
                    style={styles.itemBox}
                    onClick={() => handleItemClick(item.url,item.name)}
                >
                    {/* 왼쪽 그룹: 파트 이름 + 브랜드/쇼핑몰 */}
                    <div style={styles.leftGroup}>
                        {/* 파트 이름 (예: SHOES, BOTTOM) */}
                        <span>{item.part}</span>
                        
                        {/* 타입 (브랜드/쇼핑몰) - 붉은색 텍스트 */}
                        <span style={styles.redText}>
                            {item.type}
                        </span>
                    </div>
                    {/* 오른쪽 이름 */}
                    <span style={styles.rightName}>
                        {item.name}
                    </span>
                </div>
            ))}
        </div>
              <div style={styles.searchContainer}>
                <input
                  type="text"
                  placeholder="댓글을 입력하세요..."
                  value={searchTerm}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown} // Enter 키 이벤트 처리
                  style={styles.inputField}
                />
                  {/* <button onClick={commentpost} style={styles.searchButton}> */}
                <button onClick={ () =>{


const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
            if(storedUserObject.username == 'temp'){
                        setShowLoginModal(true);

            }else{
                                    commentpost()
            }





                }
                  
                  
                  } style={styles.searchButton}>
                  <FaPencilAlt size={20} color="#333" />
                </button>
              </div>

              {/* 댓글 섹션: InfiniteScroll로 감싸기 */}
             
                <InfiniteScroll
                  dataLength={comments.length} // 현재 댓글 수
                  next={fetchComments} // 다음 페이지 불러오기
                  hasMore={hasMore} // 더 불러올 게 있는지
                  loader={<h4>댓글 로딩 중...</h4>} // 로딩 표시
                  endMessage={<p style={{ textAlign: 'center' }}>모든 댓글을 불러왔습니다.</p>} // 끝 메시지
                  //scrollableTarget="scrollableDiv" // 스크롤 컨테이너 ID
                >
                  {comments.map((commentItem) => (
                    <div key={commentItem.id} style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img 
                          src={commentItem.user.profile.thumbnail || "https://www.studiopeople.kr/common/img/default_profile.png"} 
                          alt={commentItem.user.username} 
                          style={{ width: '30px', height: '30px', borderRadius: '50%', marginRight: '10px' }} 
                        />
                        <span style={{ fontWeight: 'bold' }}>{commentItem.user.username}</span>
                        <TimeAgo isoString={commentItem.created_at} />
                      </div>
                      <p>{commentItem.content}</p>
                    </div>
                  ))}
                </InfiniteScroll>
           

      </div>
{/* 7. 인기 데일리룩 9개 */}
      {/* <div className="flex-grid-container">
      {dailylooksArray.slice(2,11).map((dailylook, index) => (
        // Grid 아이템
        <div key={index} className="flex-grid-item">
          <img
            src={dailylook.thumbnail}
            className="flex-grid-image"
          />
        </div>
      ))}
    </div> */}
     
    </div>
  );
  function FollowUserCard({ user, onToggle }) {
    const isFollowed = user.is_followed;
    const thumbnail = user.profile?.thumbnail || "https://www.studiopeople.kr/common/img/default_profile.png";
    return (
        <div style={cardStyles.recommCard}>
            <img src={thumbnail} alt={user.username} style={cardStyles.recommImage} />
            <span style={cardStyles.recommUsername}>{user.username}</span>
            <button 
                onClick={() => onToggle(user)}
                style={isFollowed ? cardStyles.followingButton : cardStyles.followButton}
            >
                {isFollowed ? '팔로잉' : '팔로우'}
            </button>
        </div>
    );
}
}
const cardStyles = {
    // ... (기존 cardStyles 유지) ...
    
    // ⭐️ 추천 유저 카드 스타일
    recommCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        flexShrink: 0, // 카드가 줄어들지 않도록
        width: '80px', // 카드 너비 고정
    },
    recommImage: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginBottom: '5px',
    },
    recommUsername: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '5px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
    },
    followButton: {
        backgroundColor: '#e74c3c', // 빨간색
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '5px',
        fontSize: '11px',
        cursor: 'pointer',
    },
    followingButton: {
        backgroundColor: '#b7b7b7', // 회색
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '5px',
        fontSize: '11px',
        cursor: 'pointer',
    },
};
// 스타일 객체 정의 (반응형 모바일에 적합하게)
const styles = {
      toast: {
        position: 'fixed', // 화면에 고정
        bottom: '20px',    // 하단 20px 위치
        left: '50%',
        transform: 'translateX(-50%)', // 가로 중앙 정렬
        backgroundColor: 'rgba(50, 50, 50, 0.9)',
        color: 'white',
        padding: '10px 10px',
        borderRadius: '8px',
        zIndex: 9999,
        opacity: 1,
        fontSize: 13,
        transition: 'opacity 0.3s ease-in-out',
    },
   // ⭐️ 팔로우 추천 섹션 스타일
    recommFollowContainer: {
        padding: '0 1vw',
        
        position: 'relative', // X 버튼 등의 배치를 위해
    },
    recommTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        margin: '0 0 10px 0',
    },
    recommList: {
        display: 'flex',
        //overflowX: 'scroll', // ⭐️ 가로 스크롤 가능
        gap: '15px',
        paddingBottom: '10px',
        // 스크롤바 숨김 처리 필요 (App.css 또는 전역 스타일에서)
    },
    recommDivider: {
        height: '1px',
        backgroundColor: '#eee',
        margin: '15px 0',
    },
  buttonBase: {
        backgroundColor: '#000000ff',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '6px 15px',
        cursor: 'pointer',
        fontSize: '10px',
    },
  value: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: 0,
  },
container: {
       
        maxWidth: '400px', // 모바일 환경에 맞게 최대 너비 설정
        margin: '20px auto',
    },
    // 사진 속 둥근 박스 스타일
    itemBox: {
        display: 'flex',
        justifyContent: 'space-between', // 양 끝 정렬 (파트와 브랜드)
        alignItems: 'center',
        padding: '15px 20px',
        margin: '10px 0',
        backgroundColor: '#fafafa',
        borderRadius: '15px', // 둥근 모서리
        //boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)', // 약간의 그림자
        cursor: 'pointer', // 클릭 가능함을 표시
    },
    // 왼쪽 텍스트 그룹 (PART + 브랜드)
    leftGroup: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000000',
    },
    // 오른쪽 브랜드/쇼핑몰 이름
    rightName: {
        fontSize: '16px',
        color: '#000000',
    },
    // '브랜드' 텍스트의 붉은색 스타일
    redText: {
        color: '#ff4d4f', // 빨간색 계열
        marginLeft: '5px',
        fontWeight: 'normal',
        fontSize: '14px',
    },
  feedContainer: {
        maxWidth: '420px',
        margin: '0 auto',
        padding: '10px 15px',
    },
    controlPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
    },
    keywordInput: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #ddd',
    },
    filterButton: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #007bff',
        backgroundColor: '#fff',
        color: '#007bff',
        cursor: 'pointer',
    },
    resultTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '15px',
    },
    postsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '1px',
    },
    postItem: {
        border: '1px solid #eee',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    postImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
  mobileContainer: {
    maxWidth: '420px', // 일반적인 모바일 최대 너비
    margin: '0 auto',  // 중앙 정렬 (웹에서 볼 경우 대비)
    // padding: '0 5vw', // 좌우 패딩을 뷰포트 너비 기준으로 설정하여 반응성 확보
  },
  
  header: {
    paddingTop: '20px',
    position:'fixed',
    top:'0',
    width:'100%',
    maxWidth:'420px',
    backgroundColor:'white',
    zIndex:'1'
  },
  
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between', // 요소들을 양 끝으로 분산
    alignItems: 'center',
  },
  
  logo: {
    width: '100px',
    // 로고는 중앙에 위치하도록 flexbox가 처리
  },
  
  iconWrapper: {
    // 아이콘 그룹을 위한 컨테이너 (각 아이콘에 개별 마진 대신 flex 사용)
    width: '30px', 
    margin:'0 15px'
  },
  
  iconStyle: {
    // 아이콘 크기는 이미 24px로 설정됨
  },
  
  divider: {
    height: '1px', 
    backgroundColor: '#d4d4d4ff', 
    marginTop: '20px', // 수직 여백을 뷰포트 높이 기준으로 설정
  },
  infoSection: {
    display: 'flex',
    justifyContent: 'space-between', // 주간모디 그룹과 임시 박스를 양 끝으로 분산
    alignItems: 'center',
    marginBottom: '5px',
   
  },
  
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px', // 요소 사이의 간격
  },
  
  titleText: {
    color: '#000000ff',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  
  infoIcon: {
    color: '#000000ff',
    cursor: 'pointer',
  },
  placeholderBox: {
    width: '70px',
    height: '20px',
    backgroundColor: 'rgb(0, 0, 0)',
    // flexbox가 자동으로 오른쪽 끝에 배치
  },
  
  bestTitle: {
    color: '#ff0000ff',
    fontSize: 'small',
    margin: '5px 0',
  },
  dailylooksGrid: {
    display: 'flex',
    justifyContent: 'space-between', // 두 이미지를 양 끝으로 분산
    gap: '10px', // 이미지 사이 간격
    marginTop: '10px',
  },
  dailylookImage: {
    width: '47%', // 컨테이너 너비의 49%를 차지 (간격 포함 100% 미만)
    //height: '59vw',
        borderRadius: '8px',
    objectFit: 'cover',
  },
  sliderContainer: {
      // 슬라이더 자체의 좌우 패딩을 모바일 컨테이너와 동일하게 맞추려면 padding: 0 이 필요할 수 있음
      // 여기서는 모바일 컨테이너의 패딩을 따름
      marginBottom: '20px',
      // slick-dots 커스터마이징을 위해 추가 CSS 필요
  },
  bannerLink: {
      display: 'block',
  },
  bannerImage: {
      width: '100%',
      // height: '500px',
      
      display: 'block', // 인라인 요소의 기본 여백 제거
  },
  defaultTag: {
    // 배경 및 텍스트 색상
    backgroundColor: '#333333', 
    color: '#ffffff',
    
    // 모서리 둥글게
    borderRadius: '10px', 
    
    // 내부 여백 (클릭 영역 확보)
    padding: '8px 15px', 
    
    // 글꼴 설정 (폰트에 따라 다를 수 있음)
    fontSize: '14px', 
    fontWeight: 'normal',
    
    // 기타 설정
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    
    // 옆 요소와의 간격
    marginRight: '10px', 
  },
  
  // 텍스트 밑줄 스타일 (이미지와 가장 유사하게 구현하기 위해 span에 적용)
  textUnderline: {
    // 텍스트와 거의 같은 색상의 얇은 밑줄 효과
    borderBottom: '1px solid #ffffff', 
    paddingBottom: '2px', // 텍스트와 밑줄 사이의 간격
  },
  
  // 선택되었을 때의 스타일 (필요하다면)
  // activeTag: {
  //   // defaultTag 스타일을 복사하고 필요한 부분만 변경 (예: 빨간색 테두리)
  //   ...this.defaultTag,
  //   // 예시: 선택 시 배경색 변경
  //   backgroundColor: '#111111', 
  // }
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px', // 컴포넌트의 최대 너비를 제한하여 모바일에 적합하게 조정
    margin: '20px auto',
    border: '1px solid #ccc',
    borderRadius: '15px', // 둥근 모서리
    overflow: 'hidden', // 버튼과 인풋필드를 묶음
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  inputField: {
    flexGrow: 1, // 입력 필드가 남은 공간을 모두 차지하도록
    padding: '10px 15px',
    border: 'none',
    outline: 'none',
    fontSize: '16px',
    lineHeight: 1.5,
  },
  searchButton: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '10px 15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
  },
  dropdownContainer: {
    position: 'relative',
    display: 'inline-block', // 너비를 내용물에 맞춥니다.
  },
  dropdownButton: {
    padding: '10px 20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  arrow: {
    marginLeft: '10px',
    fontSize: '10px',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%', // 버튼 바로 아래에 배치
    left: 0,
    zIndex: 1000,
    minWidth: '100%',
    padding: 0,
    margin: '4px 0 0 0',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    listStyle: 'none', // 리스트 마커 제거
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  menuItem: {
    padding: '10px 20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0', // 마우스 오버 시 배경색 변경 (인라인 스타일에서는 직접 구현 어려움)
    },
  },
    modalHeader: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '5px',
    textAlign: 'center',
  },
  modalSubtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
    textAlign: 'center',
  },
  tagsGrid: {
    display: 'flex',
    flexWrap: 'wrap', // 태그를 다음 줄로 넘김
    gap: '8px',       // 태그 간의 간격
    maxHeight: '400px', // 스크롤이 필요할 경우 최대 높이 지정
    overflowY: 'auto',
    padding: '10px 0',
  },
  tagBase: {
    padding: '8px 15px',
    borderRadius: '20px', // 타원형 모양을 위한 큰 BorderRadius
    border: '1px solid transparent',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
  },
  tagDefault: {
    backgroundColor: '#f0f0f0', // 비활성화된 태그 배경색 (연한 분홍색과 유사하게)
    color: '#333',
  },
  tagSelected: {
    backgroundColor: '#e64e4e', // 선택된 태그 배경색 (이미지의 빨간색)
    color: 'white',
    fontWeight: 'bold',
  },
  confirmButton: {
    width: '100%',
    padding: '15px 0',
    marginTop: '20px',
    backgroundColor: '#e64e4e', // 이미지와 같은 빨간색
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  }
  
}
const dropdownStyles = {
  container: {
    marginBottom: '15px',
  },
  label: {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#555',
  },
  select: {
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '16px',
    appearance: 'none', // 브라우저 기본 드롭다운 스타일 제거
  }
};
const modalStyles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  content: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '350px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
  },
  buttonGroup: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  closeButton: {
    padding: '10px 15px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#eee',
    cursor: 'pointer',
  },
  saveButton: {
    padding: '10px 15px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#007bff',
    color: 'white',
    cursor: 'pointer',
  },
};
const mainStyles = {
    openButton: {
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        backgroundColor: '#f0f0f0',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '16px',
    }
}
export default Dailylook_detail;